"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeTypeEnum = void 0;
var TradeTypeEnum;
(function (TradeTypeEnum) {
    TradeTypeEnum["Buy"] = "buy";
    TradeTypeEnum["Sell"] = "sell";
})(TradeTypeEnum = exports.TradeTypeEnum || (exports.TradeTypeEnum = {}));
//# sourceMappingURL=trade-type-enum.js.map